import React from 'react';

interface LayerProps {
  children: React.ReactNode;
}

export function CenteredLayout({ children }: LayerProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className=" min-w-lg">{children}</div>
    </div>
  );
}
